module.exports = __webpack_public_path__ + "static/media/sunwei.b096a587.jpg";